import React from "react";
// import i18n from "i18n";
import styles from "./ItemLongSummaryItem.module.scss";
import i18n from "i18n";


export const ItemLongSummaryItem = ({item, stock, units, add}) => {
    return(
        <div className={styles["item-summary-container"]}>
            <div className={styles["item-summary-name"]}>{item.name}</div>
            <div className={styles["item-summary-brand"]}>{item.brand && item.brand.name}</div>
            <div className={styles["item-summary-code"]}>{item.sku}</div>
            {!add && units && <div className={styles["item-summary-units"]}>{units} {" ".concat(i18n.t("units"))}</div>}
            {add && <div className={`${styles['item-summary-units']} ${stock > 0 ? '' : styles.disabled}`}>{stock > 0 ? i18n.t("with.stock") : i18n.t("out.of.stock")} </div>}
            <div className={styles["item-summary-divider"]}></div>
        </div>
    )
}

export default ItemLongSummaryItem;